import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { LocalStorageService } from "angular-2-local-storage";

@Component({
    selector: "bo-jub-sidebar",
    templateUrl: "./jubili-sidebar.component.html",
    styleUrls: ["./jubili-sidebar.component.scss"]
})

export class JubiliSidebarComponent implements OnInit {

    // initialize a private variable _data, it's a BehaviorSubject
    private _data = new BehaviorSubject<boolean>(false);
    sidebar: string = "sidebar";
    iconNav: string = "icon-nav";

    // show font
    dashboard: boolean = false;
    company: boolean = false;
    setting: boolean = false;
    users: boolean = false;
    quotation: boolean = false;
    uploadImage: boolean = false;
    webhook: boolean = false;
    // slide jubili width
    navwidth: string = "40px";

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService
    ) { }

    @Input()
    set toggle(value) {
        // set the latest value for _data BehaviorSubject
        this._data.next(value);
    }
    get toggle(): boolean {
        // get the latest value from _data BehaviorSubject
        return this._data.getValue();
    }

    @Output("menuToggle") menuToggle = new EventEmitter<boolean>();

    ngOnInit(): void {
        this._data
            .subscribe(x => {
                this.toggleSidebar(this.toggle);
            });
        // this.navbarvisible = this.toggle;
    }

    toggleSidebar(isToggle: boolean): void {
        // // sidebar
        // this.sidebar = isToggle ? "toggle-sidebar" : "sidebar";

        // // toggle-icon-nav
        // this.iconNav = isToggle ? "toggle-icon-nav" : "icon-nav";

        if (isToggle) {
          this.dashboard = true;
          this.company = true;
          this.setting = true;
          this.users = true;
          this.quotation = true;
          this.uploadImage = true;
          this.webhook = true;

          this.navwidth = "220px";
      } else {
          this.dashboard = false;
          this.company = false;
          this.setting = false;
          this.users = false;
          this.quotation = false;
          this.uploadImage = false;
          this.webhook = false;
          this.navwidth = "40px";
      }
    }

    // check width slide
    onChangeWidth(width: string): void {
        if (width === "40px") {
            this.dashboard = true;
            this.company = true;
            this.setting = true;
            this.users = true;
            this.quotation = true;
            this.uploadImage = true;
            this.webhook = true;
            this.navwidth = "220px";
            this.menuToggle.emit(true);
        } else {
            this.dashboard = false;
            this.company = false;
            this.setting = false;
            this.users = false;
            this.quotation = false;
            this.uploadImage = false;
            this.webhook = false;
            this.navwidth = "40px";
            this.menuToggle.emit(false);
        }
    }
}
